const plt_addDynamicTitleToBreadcrumbs = () => {
  const pageTitle = window.document.title;
  const breadcrumbsId = window.document.getElementById("breadcrumbs");

  // getElementById が null を返さないことを確認
  if (breadcrumbsId !== null) {
    // 既存の li 要素が存在するか確認
    const existingDynamicIndexElement = breadcrumbsId.querySelector(`li[id="dynamicIndex"]`);

    // 既存の li 要素が存在する場合は削除
    if (existingDynamicIndexElement) {
      existingDynamicIndexElement.remove();
    }

    // ページタイトルを整形
    const formattedTitle = pageTitle.includes('|') ? pageTitle.split('|')[0].trim() : pageTitle;

    // 新しい li 要素を作成
    const newLiElement = document.createElement("li");
    // newLiElement.textContent = formattedTitle;
    newLiElement.id = "dynamicIndex"; // ID を設定
    newLiElement.setAttribute("itemprop", "itemListElement");
    newLiElement.setAttribute("itemscope", "");
    newLiElement.setAttribute("itemtype", "http://schema.org/ListItem");

    // 新しい span 要素を作成
    const newSpanElement = document.createElement("span");
    newSpanElement.textContent = formattedTitle;
    newSpanElement.setAttribute("itemprop", "name");

    // 新しい meta 要素を作成
    const newMetaElement = document.createElement("meta");
    newMetaElement.setAttribute("itemprop", "position");
    newMetaElement.setAttribute("content", (breadcrumbsId.children.length + 1).toString());

    // li 要素に span 要素と meta 要素を追加
    newLiElement.appendChild(newSpanElement);
    newLiElement.appendChild(newMetaElement);

    // breadcrumbsId（ul 要素）の最後に新しい li 要素を追加
    breadcrumbsId.appendChild(newLiElement);
  } else {
    console.error("Element with id 'breadcrumbs' not found.");
  }
};

export default plt_addDynamicTitleToBreadcrumbs;
